import ClinicReviewTimeIcon from 'components/atoms/icons/clinic-review-time.svg?react';
import { useTranslation } from 'react-i18next';
import { secondsToMinutes } from 'date-fns';

import s from './styles.module.scss';

const ClinicReviewTime = ({
  clinicReviewTimeSeconds,
}: {
  clinicReviewTimeSeconds: number;
}) => {
  const { t } = useTranslation();
  const minutes = secondsToMinutes(clinicReviewTimeSeconds);

  const label = minutes > 1 ? t('labels.minutes') : t('labels.minute');
  return (
    <div className={s.wrapper}>
      <div className={s['icon-wrapper']}>
        <ClinicReviewTimeIcon />
      </div>
      <div className={s['text-wrapper']}>
        <div>{t('labels.clinicReviewTime')}</div>
        <div className={s['minutes-wrapper']}>
          {minutes} {label}
        </div>
      </div>
    </div>
  );
};

export default ClinicReviewTime;
